export default function(password) {
    if (!password.trim()) return "Please enter your password";

    if (password.trim().length < 6)
        return "Password should be at least 6 symbols";

    if (password.trim().length > 72)
        return "Password should be less than 72 characters";
}
